import {useState, useContext, useEffect} from "react";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import FlujosEstructureContext from "context/FlujosEstructureContext";
import ErrorMessage from "components/ErrorMessage";
import {useNivelesEstructure} from "hooks/useNivelesEstructure";

const FLUJOSESTRUCTURE_VALUES = {
	flujo: [],
	predeterminado: false,
};

function Form({createFlujoEstructure, updateFlujoEstructure, setIsSearched}) {
	const {allNivelesEstructure} = useNivelesEstructure();

	let allNivelesEstructureBarrioManzana = allNivelesEstructure.filter(nivel => nivel.flujo === "barrio-manzana");
 
	let nivelesMZ = allNivelesEstructureBarrioManzana.filter((nivel) => /MZ_TIPO_NIVEL/.test(nivel.nivel)).sort((a, b) => Number(a.nivel.slice(-1)) - Number(b.nivel.slice(-1)));

	let nivelesCP = allNivelesEstructureBarrioManzana.filter((nivel) => /CP_TIPO_NIVEL/.test(nivel.nivel)).sort((a, b) => Number(a.nivel.slice(-1)) - Number(b.nivel.slice(-1)));

	let nivelesIT = allNivelesEstructureBarrioManzana.filter((nivel) => /IT_TIPO_PLACA/.test(nivel.nivel))


	const {
		flujoEstructure: selectedFlujoEstructure,
		setFlujoEstructure: setSelectedFlujoEstructure,
		message,
		setMessage,
	} = useContext(FlujosEstructureContext);

	const [form, setForm] = useState(FLUJOSESTRUCTURE_VALUES);
	const {flujo, predeterminado} = form;

	let myAbi = HelpAbility();
	// const handleChange = (e) => {
	// 	setForm({...form, [e.target.name]: e.target.value});
	// };

	const handleChangeBool = (e) => {

		if(e.target.name === "nivel"){
			const nivelesDom = Array.from(document.querySelectorAll("[name='nivel']"));
			console.log(nivelesDom);
			const valuesNiveles = nivelesDom.map((nivelDom) => ({
				value: nivelDom.value,
				checked: nivelDom.checked
			}));
			console.log(valuesNiveles);

			const valuesNivelesCheckedTrue = valuesNiveles.filter(value => value.checked);
			console.log(valuesNivelesCheckedTrue)

			const valuesNivelesCheckedTrueFormatted = valuesNivelesCheckedTrue.map(value => value.value)

			setForm({...form, flujo: [...valuesNivelesCheckedTrueFormatted]});
		}else{
			console.log(e.target, e.target.value, e.target.checked);
			setForm({...form, [e.target.name]: e.target.checked });
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		let status = Object.keys(selectedFlujoEstructure).length
			? await updateFlujoEstructure({
					flujo: form,
					id: selectedFlujoEstructure._id,
			  })
			: await createFlujoEstructure({flujo: form});
		if (!status) {
			setIsSearched({
				search: "",
				option: "",
				state: false,
			});
			setForm(FLUJOSESTRUCTURE_VALUES);
			setSelectedFlujoEstructure({});
			setMessage({message: "", status: 200});
		}
	};

	const handleReset = () => {
		setForm(FLUJOSESTRUCTURE_VALUES);
		setSelectedFlujoEstructure({});
		setMessage({message: "", status: 200});
	};

	const isVisibleForm = Object.keys(selectedFlujoEstructure).length
		? myAbi.has(C.A.FLUJOSSTRUCTURE.UPDATE)
		: myAbi.has(C.A.FLUJOSSTRUCTURE.CREATE);

	useEffect(() => {
		if (!Object.keys(selectedFlujoEstructure).length) return null;
		setForm(selectedFlujoEstructure);
	}, [selectedFlujoEstructure]);

	return (
		<>
			{isVisibleForm && (
				<div className="mt-4">
					<div className="row mb-2">
						<h6>
							{Object.keys(selectedFlujoEstructure).length
								? "Editar"
								: "Agregar"}{" "}
							Flujo
						</h6>
					</div>
					{message.status !== 200 && message.message && (
						<ErrorMessage message={message.message}></ErrorMessage>
					)}
					<div
						className="table-responsive rounded-3"
						style={{border: "1px solid black", paddingTop: "15px"}}
					>
						<div className="row mb-3 d-flex justify-content-center">
							<div
								className="col-3 themed-grid-col"
							>
								<label
									// htmlFor="name"
									className="form-label"
								>
									Niveles
								</label>

								{nivelesMZ.map(({_id, nivel}) => (
									<div key={_id}>
										<input
											className="form-check-input"
											type="checkbox"
											name="nivel"
											onChange={handleChangeBool}
											checked={
												flujo.some(value => value === _id)
											}
											id={nivel}
											value={_id}
										/>
										<label
										htmlFor={nivel}
										className="form-label ms-2"
										>
											{nivel}
										</label>
									</div>
								))}
								{nivelesCP.map(({_id, nivel}) => (
									<div key={_id}>
										<input
											className="form-check-input"
											type="checkbox"
											name="nivel"
											onChange={handleChangeBool}
											checked={
												flujo.some(value => value === _id)
											}
											id={nivel}
											value={_id}
										/>
										<label
										htmlFor={nivel}
										className="form-label ms-2"
										>
											{nivel}
										</label>
									</div>
								))}
								{nivelesIT.map(({_id, nivel}) => (
									<div key={_id}>
										<input
											className="form-check-input"
											type="checkbox"
											name="nivel"
											onChange={handleChangeBool}
											checked={
												flujo.some(value => value === _id)
											}
											id={nivel}
											value={_id}
										/>
										<label
										htmlFor={nivel}
										className="form-label ms-2"
										>
											{nivel}
										</label>
									</div>

								))}

							</div>
							<div
								className="col-3 themed-grid-col d-flex align-items-end"
							>	
								<div>
									<div>
										<label
											// htmlFor="predeterminado"
											className="form-label mb-0"
										>
											Marcar Como Predeterminado
										</label>
									</div>
									<div className="form-check form-check-inline">
										<input
											className="form-check-input"
											type="checkbox"
											name="predeterminado"
											id="predeterminado"
											onChange={handleChangeBool}
											checked={
												predeterminado === true
											}
											// value={"otro valor para hacer magia"}
										/>
									</div>
								</div>
								
							</div>

							<div
								className="col-3 themed-grid-col ms-2"
							>
								<button
									className={
										"d-block d-block w-100 mb-2 btn btn-" +
										(true ? "success" : "primary")
									}
									type="submit"
									onClick={handleSubmit}
								>
									<i className="bi bi-save" />
									{Object.keys(selectedFlujoEstructure).length
										? "Actualizar"
										: "Guardar"}
								</button>
								<button
									type="reset"
									className="d-block w-100 btn btn-secondary"
									onClick={handleReset}
								>
									<i className="bi bi-eraser" /> Limpiar
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
}
export default Form;
